import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';

import { connect } from 'react-redux';

import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class tradesecrets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: ''
        };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {

        var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }



        return (
            <div style={{ height: "100%",}}>



            <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>


                <NavBar2/>




                ​

                ​












            </div>
            {this.state.width<500 &&<div style={{height: "16vw",}} ></div>}
            {this.state.width>=500 &&<div style={{height: "10vw", }} ></div>}

            <div>
                <div style={{width: "90%", margin: "auto", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >
                    {lang==="en" &&  <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top", minWidth:"20em", display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>Trade Secrets Litigation</span><p/>
                        <span style={{fontSize: ".8em"}}>The Morrow Firm is at the forefront of trade secrets law and has first-hand experience handling high-profile and high-stakes trade secrets litigation. </span><p/>

                        <span style={{fontSize: ".8em"}}>Representative experience:</span><p/>
                        ​

                        <ul>
                            <span style={{fontSize: ".8em"}}><li>Served as trial counsel for T-Mobile in a three-week jury trial in Seattle, winning verdicts on misappropriation of trade secrets and breach of contract claims against Huawei Devices USA. See <a href="https://www.seattletimes.com/business/technology/july-awards-t-mobile-48m-in-trade-secrets-case-against-huawei/" target="_blank" rel="noopener noreferrer"> Seattle Times</a>, Jury awards T-Mobile $4.8M in trade-secrets case against Huawei; <a href="https://www.nytimes.com/2014/09/06/business/t-mobile-accuses-huawei-of-theft-from-laboratory.html" rel="noopener noreferrer"> New York Times</a>, T-Mobile Accuses Huawei of Theft From Laboratory.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented a Chinese businessman accused of trade secrets theft.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Defended a Hong Kong-based technology company in a trade secrets case.</li></span><br/>
                        </ul>

                    </div>}

                    {lang==="zh" &&  <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top", minWidth:"20em", display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>商业秘密诉讼与纠纷</span><p/>
                        <span style={{fontSize: ".8em"}}>沫若律师事务所在商业秘密法领域具有深厚的法律功底，拥有处理重大商业秘密诉讼的最前沿经验。 </span><p/>

                        <span style={{fontSize: ".8em"}}>代表经验：</span><p/>
                        ​

                        <ul>
                            <span style={{fontSize: ".8em"}}><li>在西雅图进行为期三周的陪审团审判中担任T-Mobile的出庭律师，赢得了对华为美国终端公司盗用商业机密和违反合同索赔的判决。参见<a href="https://www.seattletimes.com/business/technology/july-awards-t-mobile-48m-in-trade-secrets-case-against-huawei/" target="_blank" rel="noopener noreferrer">西雅图时报报道</a>，Jury awards T-Mobile $4.8M in trade-secrets case against Huawei；<a href="https://www.nytimes.com/2014/09/06/business/t-mobile-accuses-huawei-of-theft-from-laboratory.html" target="_blank" rel="noopener noreferrer">纽约时报报道</a>，T-Mobile Accuses Huawei of Theft From Laboratory。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表受到窃取商业秘密指控的中国商人。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>在商业秘密案件中为一家香港科技公司辩护。</li></span><br/>
                        </ul>

                    </div>}

                    <div style={{width: "49%", maxWidth:"50%",  height:"100%",minWidth:"20em", verticalAlign:"top", display: "inline-block",  padding: "5px", top:"0px", }} ><img  alt="Trade Secrets Litigation" style={{top:"0px", width: "100%"}} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/tradesecrets.jpg?alt=media&token=7d72b576-dd5d-4da6-9b17-8336a54c0e41"/>

                    </div>
                </div>
            </div>
            <SiteFoot lang={lang}/>
            </div>


        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang };
}

export default connect(mapStateToProps, { getUser })(tradesecrets);



// WEBPACK FOOTER //
// ./src/Containers/tradesecrets.js